import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { v2ErrorMessage } from '../../../shared/utils/v2-api-response.util';
import { FinanciacionPropiaModel } from '../../../../modules/finanzas/financiacion-propia/financiacion-propia.model';
import {
  EMPTY_FINANCING_LIST_SUMMARY,
  FinancingListFilter,
  FinancingListResult,
} from '../../financing-detail/financing-detail.model';

@Injectable({ providedIn: 'root' })
export class OwnFinancingReadService {
  private readonly base = `${environment.apiUrl}/api/v2/own-financings`;

  constructor(private http: HttpClient) { }

  list(filter: FinancingListFilter): Promise<FinancingListResult<FinanciacionPropiaModel>> {
    const fallback = 'No se pudo cargar la lista de financiación propia';
    return firstValueFrom(this.http.post<any>(`${this.base}/list`, filter))
      .catch(error => {
        throw { status: error && error.status, error: { message: v2ErrorMessage(error && error.error, fallback) } };
      })
      .then(response => {
        if (!response || response.isSuccess === false) {
          throw { error: { message: v2ErrorMessage(response, fallback) } };
        }
        return {
          items: Array.isArray(response.values) ? response.values : [],
          total: Number(response.total) || 0,
          summary: response.summary || { ...EMPTY_FINANCING_LIST_SUMMARY },
        };
      });
  }
}
